import { supabase } from '../lib/supabaseClient';
import type { BranchIncomeRecord, ExpenseRecord } from '../types/db';

export async function fetchIncomeReport(params: {
  branchId: string;
  reportType: 'MONTHLY' | 'ANNUAL';
  year: number;
  month?: number;
}): Promise<BranchIncomeRecord[]> {
  let query = supabase.from('branch_incomes').select('*');

  if (params.reportType === 'MONTHLY') {
    const period = `${params.year}-${String((params.month ?? 0) + 1).padStart(2, '0')}`;
    query = query.eq('accounting_period', period);
  } else {
    // TAHUN AJARAN: JULI (Y-1) ke JUNI (Y)
    const startYear = params.year - 1;
    const endYear = params.year;
    const periods = ['07', '08', '09', '10', '11', '12']
      .map((m) => `${startYear}-${m}`)
      .concat(['01', '02', '03', '04', '05', '06'].map((m) => `${endYear}-${m}`));

    query = query.in('accounting_period', periods);
  }

  if (params.branchId !== 'ALL') {
    query = query.eq('branch_id', params.branchId);
  }

  const { data, error } = await query.order('date', { ascending: true });
  if (error) throw error;

  return data ?? [];
}

export async function fetchExpenseReport(params: {
  branchId: string;
  reportType: 'MONTHLY' | 'ANNUAL';
  year: number;
  month?: number;
}): Promise<ExpenseRecord[]> {
  let query = supabase.from('expenses').select('*');

  if (params.reportType === 'MONTHLY') {
    const period = `${params.year}-${String((params.month ?? 0) + 1).padStart(2, '0')}`;
    query = query.eq('accounting_period', period);
  } else {
    // TAHUN AJARAN: JULI (Y-1) ke JUNI (Y)
    const startYear = params.year - 1;
    const endYear = params.year;
    const periods = ['07', '08', '09', '10', '11', '12']
      .map((m) => `${startYear}-${m}`)
      .concat(['01', '02', '03', '04', '05', '06'].map((m) => `${endYear}-${m}`));

    query = query.in('accounting_period', periods);
  }

  if (params.branchId !== 'ALL') {
    query = query.eq('branch_id', params.branchId);
  }

  const { data, error } = await query.order('date', { ascending: true });
  if (error) throw error;

  return data ?? [];
}
